import * as Style from './styled'

function RegisterByYourCellphone() {
  return (
    <Style.Message role="region">
      <Style.StreamlineSelfie />
      <Style.Title>Cadastre-se pelo celular!</Style.Title>
      <Style.Text>
        Já que vamos precisar da sua foto, cadastre-se direto pelo celular usando o app
        Fretebras ou nosso site.
      </Style.Text>
    </Style.Message>
  )
}

export default RegisterByYourCellphone
